import { ButtonVariant } from './Button'

import styles from './Button.module.scss'

const VARIANT_CLASS_MAP: { [key in ButtonVariant]: string } = {
  primary: `${styles.primaryButton} button-large`,
  primaryGhost: `${styles.primaryGhostButton} button-large`,
  secondary: `${styles.secondaryButton} button-large`,
  secondaryGhostButton: `${styles.secondaryGhostButton} button-large`,
  danger: `${styles.dangerButton} button-large`,
  dangerGhost: `${styles.dangerGhostButton} button-large`,
  link: `${styles.linkButton} button-link-large`,
  dark: `${styles.darkButton} button-large`,
  darkLink: `${styles.darkLinkButton} button-link-large`,
  darkGhost: `${styles.darkGhostButton} button-large`,
  white: `${styles.whiteButton} button-large`,
  header: `${styles.headerButton} button-large`,
  borderless: `${styles.borderlessButton} button-large`,
  lightPurple: `${styles.lightPurpleButton} button-large`,
  dashedButton: `${styles.dashedButton} button-large`,
  grayGhost: `${styles.grayGhostButton} button-large`,
  grayDarkGhostButton: `${styles.grayDarkGhostButton} button-large`,
  cyanGhostButton: `${styles.cyanGhostButton} button-large`,
}

export const useButtonClassName = (variant?: ButtonVariant, className?: string) => {
  const variantClass = variant ? VARIANT_CLASS_MAP[variant] : ''
  return `${className ? className : ''} ${styles.button} ${variantClass}`
}
